export default __webpack_public_path__ + "assets/audios/74d0f17eab36d0051fb14b745adf1997.wav";